const NextLegacyImageMock: React.FC<object> = () => null;
export default NextLegacyImageMock;
